/* eslint-disable camelcase */
import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { ROLLOVER_DISPLACEMENT_TYPE_SECONDARY } from '../../utils/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { modifyMetricData, modifyMetricDataByKey, modifyRolloverDisplacementResults } from '../../utils/getMetrics';
import store from '../store';
import { listHydraulics } from './hydraulics';
import { enqueueSnackbar } from './snackbar';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}
export const addNewDisplacementRow = () => (dispatch) => {
  const { displacement } = store.getState();
  const newData = [...displacement.data];
  const existUnit = { ...displacement.units };
  const nextId = newData.length - 1;
  const newRow = {
    flow_in: '',
    fluid_id: '',
    fluid_volume: '',
    pumps_output: '',
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true,
    runNumber: newData.length + 1,
    step_size: 100,
    track: newData?.length === 0
  };
  newData.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_SUCCESS,
    payload: {
      data: newData,
      units: existUnit,
      paginatedElements: newData.length,
    },
  });
};
export const listDisplacement = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId
    }
  };
  return fetch
    .post('hydraulicsDisplacements/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: displacement = [], units = {} } = data || [];
      const modifiedDisplacementData = modifyMetricData(displacement, units?.inputs, currentUnit);
      const updatedResult = modifiedDisplacementData.map((item, index) => {
        return {
          ...item,
          runNumber: index + 1,
        };
      });
      if (updatedResult?.length) {
        const updatedResultsWithTarget = updatedResult?.map((item) => {
          if (item?.target_data) {
            const targetData = modifyMetricData(
              [item.target_data],
              units.inputs.target_data,
              currentUnit
            );
            const targetRunsECDSpan = item.target_data?.ecd_span?.length
              ? modifyMetricData(
                item.target_data?.ecd_span,
                units.inputs.ecd_span,
                currentUnit
              )
              : [];
            const targetControlsTable = item.target_data?.controls_table?.length
              ? modifyMetricDataByKey(
                item.target_data?.controls_table,
                units.inputs.target_data?.controls_table,
                currentUnit,
                'parameter'
              )
              : [];
            targetData[0].ecd_span = targetRunsECDSpan;
            targetData[0].controls_table = targetControlsTable;
            if (!targetData[0]?.anchor_point) {
              targetData[0].anchor_point = 'None';
              targetData[0].target_ecd = null;
            }
            return { ...item, target_data: targetData[0] };
          }
          return item;
        });
        dispatch({
          type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_SUCCESS,
          payload: {
            ...data,
            data: updatedResultsWithTarget,
            paginatedElements: modifiedDisplacementData.length,
            units: data.units
          },
        });
        return;
      }
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_SUCCESS,
        payload: {
          ...data,
          data: updatedResult,
          paginatedElements: modifiedDisplacementData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
export const createDisplacements = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_LOADING,
  });
  const { query, isDisplacementResults } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
    },
    input: payload.inputs
  };
  return fetch
    .post('hydraulicsDisplacements/create', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Displacements Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDisplacement(payload));
      if (isDisplacementResults) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};
export const updateDisplacement = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_LOADING,
  });
  const { query, isDisplacementResults } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
      _id: payload._id
    },
    input: payload.inputs
  };
  return fetch
    .put('hydraulicsDisplacements', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Displacement Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDisplacement(payload));
      if (isDisplacementResults) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};
export const deleteDisplacement = (payload, hydraulicsBody) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_LOADING,
  });
  const { query, isDisplacementResults } = hydraulicsBody;
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
      _id: payload._id
    },
  };
  return fetch
    .deleteAction('hydraulicsDisplacements', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Displacement Deleted Successfully',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listDisplacement(payload));
      if (isDisplacementResults) {
        dispatch(listHydraulics(query));
      }
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(listDisplacement(payload));
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
    });
};

export const runDisplacement = (body, disableLoader, onClose) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_LIST_LOADING,
  });
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_LIST_LOADING,
  });
  const { runId, query } = body;
  const input = {
    input: {
      url: `/runs/displacement/${runId}`,
      method: 'POST',
    }
  };
  return fetch
    .post('premiumHydraulics/proxy', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Displacement Simulation Completed Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      disableLoader();
      onClose();
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_SET_FALSE,
      });

      dispatch(listHydraulics(query));
    })
    .catch(async (error) => {
      disableLoader();
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_SET_FALSE,
      });

      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listHydraulics(query));
    });
}; export const listDisplacementResults = (payload) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_RESULT_LIST_LOADING,
  });

  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
      runId: payload.runId,
    },
  };

  return fetch
    .post('hydraulicsDisplacements/results/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: displacementData, units } = data;

      displacementData.secondary_fields = [...ROLLOVER_DISPLACEMENT_TYPE_SECONDARY];

      const fields = displacementData?.results?.[0] || {};
      const depthsSummary = fields?.depths_summary ?? {};

      const flatKeys = Object.keys(fields).filter(
        (key) => key.endsWith('_esd') || key.endsWith('_ecd')
      );

      const nestedKeys = Object.keys(depthsSummary).flatMap((depth) => [
      `${depth}_esd`,
      `${depth}_ecd`,
      ]);

      const esdEcdKeys = [...new Set([...flatKeys, ...nestedKeys])];

      const omitList = ['icp_esd', 'icp_ecd', 'lp_esd', 'lp_ecd', 'bh_esd', 'bh_ecd'];
      const filteredKeys = esdEcdKeys.filter((key) => !omitList.includes(key));

      const groupedFields = filteredKeys.reduce((acc, key) => {
        const prefix = key.replace(/_(esd|ecd)$/, '');
        if (!acc[prefix]) acc[prefix] = [];
        acc[prefix].push(key);
        return acc;
      }, {});

      const secondaryFieldsMap = new Map(
        displacementData.secondary_fields.map(item => [
          item.label.toLowerCase(),
          item
        ])
      );

      Object.entries(groupedFields).forEach(([prefix, fieldArray]) => {
        const formattedLabel = prefix.replace(/_/g, ' ');
        const key = formattedLabel.toLowerCase();
        const existing = secondaryFieldsMap.get(key);

        secondaryFieldsMap.set(key, {
          label: existing?.label ?? formattedLabel,
          field: fieldArray,
        });
      });

      displacementData.secondary_fields = Array.from(secondaryFieldsMap.values());

      if (units?.bh_ecd !== undefined && Array.isArray(displacementData?.secondary_fields)) {
        displacementData.secondary_fields.forEach((sec) => {
          sec.field?.forEach((fKey) => {
            if (units[fKey] === undefined) {
              if (fKey.endsWith('_ecd')) units[fKey] = units.bh_ecd;
              if (fKey.endsWith('_esd')) units[fKey] = units.bh_esd;
            }
          });
        });
      }

      if (displacementData?.results) {
        const resultsData = modifyRolloverDisplacementResults(
          displacementData.results,
          units,
          currentUnit
        );
        displacementData.results = resultsData;
      }

      if (displacementData?.run_details_copy?.target_data) {
        const targetData = modifyMetricData(
          [displacementData?.run_details_copy?.target_data],
          units.target_data,
          currentUnit
        );
        displacementData.run_details_copy.target_data = targetData[0];
      }
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_RESULT_LIST_SUCCESS,
        payload: {
          data: [displacementData],
          paginatedElements: 1,
          units,
          ph_version: displacementData?.run_details_copy?.ph_version
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_DISPLACEMENT_RESULT_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
